import { DownloadOutlined } from '@ant-design/icons'
import { Button, message } from 'antd'
import { FC } from 'react'
import downloadFileByBlob from '../../../helpers/download-file-by-blob'
import useErrorModal from '../../../hooks/api/use-error-modal'
import { useLazyDownloadUploadedFileQuery } from '../../../store/api/upload-api'
import UploadedFile from '../../../types/api/uploaded-file'
import { DocumentId } from '../../../types/strapi/strapi'

interface DownloadBlankPreviewFilesProps {
    shipmentDocumentId: DocumentId
    blankPreviewFiles?: UploadedFile[]
}

const DownloadBlankPreviewFiles: FC<DownloadBlankPreviewFilesProps> = ({
    shipmentDocumentId,
    blankPreviewFiles,
}) => {
    const [downloadUploadedFile, downloadState] = useLazyDownloadUploadedFileQuery()

    useErrorModal(downloadState, 'Ошибка скачивания превью')

    const onClick = async () => {
        if (!blankPreviewFiles?.length) {
            message.info('Превью ещё не загружено')
            return
        }

        for (const file of blankPreviewFiles) {
            const downloadRes = await downloadUploadedFile(file.url)
            if ('error' in downloadRes && downloadRes.error) return
            if (!downloadRes.data) {
                message.error(`Не удалось скачать «${file.name}»`)
                return
            }
            downloadFileByBlob(downloadRes.data, file.name)
        }
    }

    return (
        <Button
            size='small'
            icon={<DownloadOutlined />}
            title='Скачать рабочий файл превью'
            onClick={onClick}
            disabled={!shipmentDocumentId || !blankPreviewFiles?.length}
            loading={downloadState.isLoading || downloadState.isFetching}
        >
            Превью
        </Button>
    )
}

export default DownloadBlankPreviewFiles
